import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgViewGraph = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M0 14.372q0 .28.168.45a.62.62 0 0 0 .46.178H15.27q.3 0 .512-.207a.68.68 0 0 0 .219-.517.68.68 0 0 0-.22-.517.7.7 0 0 0-.51-.207H1.636q-.197 0-.197-.207V1.724a.7.7 0 0 0-.212-.51A.67.67 0 0 0 .724 1a.69.69 0 0 0-.52.214.71.71 0 0 0-.204.51zm1.316-4.034 3.128-3.25q.095-.096.197-.096.096 0 .19.096l2.61 2.733q.249.266.511.392.264.125.541.125.534 0 1.053-.517L12.55 6.77l1.14 1.16q.161.162.337.162a.48.48 0 0 0 .321-.125.67.67 0 0 0 .205-.355l1.103-4.344a.5.5 0 0 0-.036-.37.55.55 0 0 0-.256-.25A.5.5 0 0 0 15 2.61l-4.29 1.108a.66.66 0 0 0-.352.207.5.5 0 0 0-.124.325.46.46 0 0 0 .16.332l1.134 1.153L8.69 8.66q-.096.104-.198.104-.094 0-.19-.104l-2.61-2.726a1.7 1.7 0 0 0-.518-.391 1.23 1.23 0 0 0-1.067-.008q-.255.118-.52.4L.293 9.31z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgViewGraph);
export default ForwardRef;
